import React, { useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, Select } from "antd";
import { CloseCircleOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import "./MetalForm.css";

export interface MetalFormProps {
  showForm: boolean;
  closeForm: () => void;
  editMetalData: any;
  postMetal: (metalInfo: any) => void;
  getMetalsForm?: () => void;
  categories: any;
}

const MetalForm = (props: MetalFormProps) => {
  const [metalInfo, setMetalInfo] = useState({
    name: "",
    displayName: "",
    categoryID: "",
  });
  const [nameFormStatus, setNameFormStatus] = useState("") as any;
  const [nameFormMessage, setNameFormMessage] = useState("");
  const [categoryFormStatus, setCategoryFormStatus] = useState("") as any;
  const [categoryFormMessage, setCategoryFormMessage] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const updateName = (value: any) => {
    setNameFormStatus("");
    setNameFormMessage("");
    let metal = { ...metalInfo };
    metal.name = value;
    setMetalInfo(metal);
  };

  const updateDisplayName = (value: any) => {
    let metal = { ...metalInfo };
    metal.displayName = value;
    setMetalInfo(metal);
  };

  const updateCategory = (value: any) => {
    let metal = { ...metalInfo };
    metal.categoryID = value;
    setMetalInfo(metal);
  };

  const closeForm = () => {
    resetSupplierInfo();
    props.closeForm();
  };

  const validateForm = () => {
    let metal = { ...metalInfo };
    let validationFormStatus = true;
    if (metal.name === "") {
      validationFormStatus = false;
      setNameFormStatus("error");
      setNameFormMessage("Name must be entered");
    }
    if (metal.categoryID === "") {
      validationFormStatus = false;
      setCategoryFormStatus("error");
      setCategoryFormMessage("Category must be selected");
    }
    return validationFormStatus;
  };

  const openCancelMetalModal = () => {
    setIsCancelModalOpen(true);
  };

  const confirmCancelSupplier = () => {
    resetSupplierInfo();
    setIsCancelModalOpen(false);
    closeForm();
  };

  const declineCancelSupplier = () => {
    setIsCancelModalOpen(false);
  };

  const resetSupplierInfo = () => {
    setMetalInfo({
      name: "",
      displayName: "",
      categoryID: "",
    });
    setNameFormStatus("");
    setNameFormMessage("");
    setCategoryFormStatus("");
    setCategoryFormMessage("");
  };

  const saveMetalInfo = () => {};

  const addMetalInfo = () => {
    props.postMetal(metalInfo);
    props.getMetalsForm && props.getMetalsForm();
    closeForm();
  };

  const generateMetalsCategoryList = () => {
    // console.log("cet", props.categories);
    // const categories = [
    //   "Aluminium",
    //   "Copper",
    //   "Brass",
    //   "Stainless Steel",
    //   "Battery",
    //   "Wires",
    //   "Zinc",
    //   "Alloys",
    //   "Electronic Scrap",
    //   "Household Scrap",
    //   "Besi",
    //   "Paper",
    //   "Plastic",
    //   "Others",
    //   "Lead",
    // ];
    const sortedCategoriesOptions = props.categories.map((category: any) => {
      return {
        label: category.name,
        value: category.categoryID,
      };
    });
    return sortedCategoriesOptions.sort((a: any, b: any) => a.label.localeCompare(b.label));
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="metal-form">
        <Row>
          <Col span={20}>
            <Row justify="start">New Metal</Row>
          </Col>
          <Col span={4}>
            <Row justify="end">
              <CloseCircleOutlined onClick={() => openCancelMetalModal()} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Form layout="vertical">
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="metal-form-label">Name</label>}
                  validateStatus={nameFormStatus}
                  help={nameFormMessage}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={metalInfo.name}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateName(e.target.value)}
                  />
                </Form.Item>
              </Row>
              <Row align="middle">
                <Form.Item label={<label className="metal-form-label">Display Name</label>} style={{ width: "100%" }}>
                  <Input
                    placeholder="Display Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={metalInfo.displayName}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateDisplayName(e.target.value)}
                  />
                </Form.Item>
              </Row>
              <Row align="middle">
                <Form.Item label={<label className="metal-form-label">Category</label>} style={{ width: "100%" }}>
                  <Select
                    showSearch
                    placeholder="Select a Material"
                    onChange={(value: any) => updateCategory(value)}
                    value={metalInfo.categoryID ? metalInfo.categoryID : null}
                    onSearch={() => {}}
                    options={generateMetalsCategoryList()}
                    style={{ width: "100%" }}
                    filterOption={(input: any, option: any) => {
                      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                    }}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button className="cancel-button" onClick={() => openCancelMetalModal()}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={props.editMetalData ? <SaveOutlined /> : <PlusOutlined />}
            onClick={() => (props.editMetalData ? validateForm() && saveMetalInfo() : validateForm() && addMetalInfo())}
          >
            {props.editMetalData ? "Save" : "Add Metal"}
          </Button>
        </Row>
      </div>
      <Modal
        title="Cancel Metal Add"
        open={isCancelModalOpen}
        okText="Confirm"
        okType="danger"
        onOk={confirmCancelSupplier}
        onCancel={declineCancelSupplier}
      >
        <p>Are you sure you want to cancel?</p>
        <p>Your changes will not be saved.</p>
      </Modal>
    </Row>
  ) : null;
};

export default MetalForm;
